import React, {Component} from "react";
import ReactGA from "react-ga";
import logger from "./modules/common/Logger";
import AuthService from "./modules/service/AuthService";
import DispatchedModal from "./modules/common/DispatchedModal";
import BotApp from "./BotApp";
import MocksApp from "./MocksApp";
import SiteService from "./modules/service/SiteService";

// track page views
ReactGA.initialize(SiteService.getAnalyticsSiteId());

const logPageView = () => {
    ReactGA.set({page: window.location.pathname});
    ReactGA.pageview(window.location.pathname);
};

// validate authentication for private routes
const requireAuth = (nextState, replace) => {
    if (!AuthService.loggedIn()) {
        logger.info(`User must be authenticated to access: ${nextState.location.pathname}`);
        AuthService.setPostLoginUrl(nextState.location.pathname);
        replace({pathname: '/login'})
    }
};

class App extends Component {
    render() {
        return (
            <div>
                <DispatchedModal modalId="default"/>
                <DispatchedModal modalId="loading"/>

                {SiteService.isBotSite() &&
                <BotApp
                    logPageView={logPageView}
                    requireAuth={requireAuth}
                />}

                {SiteService.isMocksSite() &&
                <MocksApp
                    logPageView={logPageView}
                    requireAuth={requireAuth}
                />}
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js